import {
  
  Directive,
  EventEmitter,
  Input,
  Output,
  ViewContainerRef,
} from "@angular/core";
import { AccountingEntitiesListComponent } from "src/components/general components/accounting-entities-list/accounting-entities-list.component";
import { AddressesForwardListComponent } from "src/components/general components/addresses-forward-list/addresses-forward-list.component";
import { ReporthtmlListComponent } from "src/components/general components/reporthtml-list/reporthtml-list.component";
import { GenericTableAnagraphTable } from "src/model/class/general classes/generic-table-anagraph-table";

/**
 * This Directive is used in order to draw the list of objects (displayed in the left part of the screen) in the subcomponent "Table" contained inside
 * the "StructureTableAnagraphComponent" component. It does so based on the selector passed throug its "drawTableComponent(...)" method.
 */
@Directive({
    selector: "[appStructureTableAnagraph_Table]",
    standalone: false
})
export class StructureTableAnagraph_TableDirective {
  @Output() changedSelected = new EventEmitter<any>();
  @Input("allowDetectionListChange") allowDetectionListChange: boolean = true;

  private componentInstanceRef: GenericTableAnagraphTable = null;

  constructor(
    private viewContainerRef: ViewContainerRef,
    
  ) {
    viewContainerRef.constructor.name === "ViewContainerRef_"; // true
  }

  /**
   * Send the current objet to the anagraph component
   * @param currentObject
   */
  public ChangeCurrentObject(currentObject: any): void {
    this.componentInstanceRef.CurrentObject = currentObject;
    this.componentInstanceRef.OnChanges();
  }

  public ChangeDetectionList(obj: any) {
    if (
      this.componentInstanceRef != null &&
      this.componentInstanceRef.allowDetectionListChange != null
    ) {
      this.componentInstanceRef.allowDetectionListChange = obj;
      this.componentInstanceRef.OnChanges();
    }
  }

  /**
   * Draw the component with the list of object in the left part of the screen
   * @param tableToLoad selector of the anagraph table component to load
   */
  public drawTableComponent(tableToLoad: string): void {
    const componentsHostViewRef = this.viewContainerRef;

    componentsHostViewRef.clear();

    let compFactory: any = null;

    switch (tableToLoad) {
      case "app-reporthtml-list":
        compFactory = this.viewContainerRef.createComponent(
          ReporthtmlListComponent
        );
        break;
      case "app-accounting-entities-list":
        compFactory = this.viewContainerRef.createComponent(
          AccountingEntitiesListComponent
        );
        break;
      
      case "app-addresses-forward-list":
        compFactory = this.viewContainerRef.createComponent(
          AddressesForwardListComponent
        );
        break;
      
     
     
    }

    if (compFactory != null) {
      const componentRef = componentsHostViewRef.createComponent(compFactory);
      this.componentInstanceRef =
        componentRef.instance as GenericTableAnagraphTable;
      this.componentInstanceRef.changedSelected.subscribe((objectSelected) =>
        this.changedSelected.emit(objectSelected)
      );
    }
  }
}
